import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateDecoratorService {
  private readonly translate = inject(TranslateService);

  #prefix: string = '';
  #decoratorTemplateFunction!: TranslateDecoratorTemplate;
  #decoratorFunction!: TranslateDecorator;
  private templates: JSONObject[] = [];

  constructor() {
    this.#decoratorTemplateFunction = this.decoratorTemplateFunction.bind(this);
    this.#decoratorFunction = this.decoratorFunction.bind(this);
  }

  get decorator(): TranslateDecoratorTemplate | TranslateDecorator {
    if (this.templates.length > 0) {
      return this.#decoratorTemplateFunction;
    }
    return this.#decoratorFunction;
  }

  path(values: string[]): TranslateDecoratorService {
    this.#prefix = values.join('.');
    return this;
  }

  assignTemplates(templates: JSONObject[]): TranslateDecoratorService {
    this.templates = this.templates.concat(templates);
    return this;
  }

  private decoratorTemplateFunction(
    translationKey: string,
    indexTemplate: number,
    interpolateParams?: Record<string, JSONValue>
  ): string {
    const template: JSONObject | undefined = this.templates.find(
      (temp: JSONObject) => {
        return Object.keys(temp)[0] === translationKey;
      }
    );

    if (template) {
      const templateValue: JSONValue = Object.values(template)[0];
      return template
        ? this.translate.instant(
            `${this.#prefix}.${templateValue[indexTemplate as keyof JSONValue]}`,
            interpolateParams
          )
        : '';
    }
    return '';
  }

  private decoratorFunction(
    translationKey: string,
    interpolateParams?: Record<string, JSONValue>
  ): string {
    return this.translate.instant(
      `${this.path}.${translationKey}`,
      interpolateParams
    );
  }
}
